import { Component } from '@angular/core';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.page.html',
  styleUrls: ['./public-layout.page.scss']
})
export class PublicLayoutPage {

}
